import * as React from "react";
function XxlIcon() {
    return React.createElement("path", { d: "M7.47949 43.4352V25.4353H41.4794V43.4352H7.47949ZM9.74869 41.166H39.2102V27.7045H9.74869V41.166Z", fill: "currentColor" });
}
export default XxlIcon;
//# sourceMappingURL=Xxl.js.map